/** Angular Imports */
import {
    provideHttpClient,
    withFetch,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {
    ApplicationConfig,
    provideBrowserGlobalErrorListeners,
    provideZonelessChangeDetection,
} from '@angular/core';
import {
    provideClientHydration,
    withEventReplay,
    withNoIncrementalHydration,
} from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

/** Third Party Services Imports */
import { provideAuth0 } from '@auth0/auth0-angular';

import { provideEnvironmentInitializer } from '@core';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideHttpClient(
            withFetch(),
            withInterceptors([authInterceptor]),
            withInterceptorsFromDi(),
        ),
        provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
        provideEnvironmentInitializer(),
    ],
};

// Auth0 configuration - only for browser
export const browserOnlyProviders = [
    provideAuth0({
        domain: 'auth0.n-compass.online',
        clientId: 'QYJzGGgCAyz51d2noULXBeIwyQqZhdHP',
        authorizationParams: {
            audience: 'https://api.ntv360.com',
            scope: 'openid profile email read:data offline_access',
            redirect_uri:
                typeof window !== 'undefined'
                    ? window.location.origin + '/auth'
                    : 'https://local-dev-v2.n-compass.online:4200/auth',
        },
        skipRedirectCallback: true,
    }),
];
